var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVelkykvet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    zoomAndPan: "magnify",
    viewBox: "0 0 810 809.999993",
    height: 1080,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.739348, 0, 0, 1.63919, -33.966206, -11.743397)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 315.741798 97.700482 C 315.741798 97.700482 358.993899 58.220711 385.993056 106.991943 C 404.956697 141.245715 365.030643 171.193339 345.417963 167.254179 C 363.505737 181.623891 381.050023 194.470842 356.790757 232.678072 C 347.241563 247.719801 313.599293 249.085281 304.519473 221.947257 C 304.429641 255.100066 276.321052 273.856949 253.815766 266.333701 C 231.312726 258.810454 214.222093 241.419051 223.50179 211.240273 C 202.972819 235.766488 166.579428 232.790075 158.474291 203.609789 C 150.369154 174.42712 169.047576 156.249315 195.783973 154.57404 C 165.809114 140.318713 162.429167 108.467043 179.730906 93.677916 C 197.030399 78.891173 216.387056 76.889422 236.570172 98.484502 C 226.398888 56.08551 259.383135 40.633899 278.243468 43.286219 C 297.106046 45.938539 320.74996 60.55847 315.741798 97.700482 Z M 315.741798 97.700482 ",
    stroke: "#383e60",
    strokeWidth: 7.33,
    strokeOpacity: 1,
    strokeMiterlimit: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.739348, 0, 0, 1.63919, -33.966206, -11.743397)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 264.741643 127.359759 C 283.498669 125.453329 321.288955 135.647961 305.242625 170.468895 C 290.303481 202.885346 253.555252 193.763081 238.490342 177.367787 C 223.425432 160.972494 238.674499 130.007313 264.741643 127.359759 Z M 264.741643 127.359759 ",
    stroke: "#383e60",
    strokeWidth: 7.33,
    strokeOpacity: 1,
    strokeMiterlimit: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.739348, 0, 0, 1.63919, -33.966206, -11.743397)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 264.692236 473.000188 C 264.692236 473.000188 247.729614 396.437981 192.558986 362.575027 C 137.386112 328.712074 78.563793 349.816248 91.504165 408.160139 C 101.293661 452.293981 213.451779 469.258821 264.692236 473.000188 Z M 264.692236 473.000188 ",
    stroke: "#383e60",
    strokeWidth: 7.33,
    strokeOpacity: 1,
    strokeMiterlimit: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.739348, 0, 0, 1.63919, -33.966206, -11.743397)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 263.769207 473.000188 C 263.769207 473.000188 355.957561 453.638014 381.964069 402.838818 C 407.966085 352.037238 375.114341 320.333316 330.202584 340.012434 C 285.290827 359.691553 266.129556 444.372767 263.769207 473.000188 Z M 263.769207 473.000188 ",
    stroke: "#383e60",
    strokeWidth: 7.33,
    strokeOpacity: 1,
    strokeMiterlimit: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.739348, 0, 0, 1.63919, -33.966206, -11.743397)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 252.23696 286.587132 C 252.23696 286.587132 232.163888 353.567148 263.993788 473.000188 ",
    stroke: "#383e60",
    strokeWidth: 7.33,
    strokeOpacity: 1,
    strokeMiterlimit: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVelkykvet);
export default __webpack_public_path__ + "static/media/velkykvet.3dbed2281be5586fc627eaf4b80cd60c.svg";
export { ForwardRef as ReactComponent };